// Handles the redirect from Emergent Auth. Reads #session_id=... from the URL fragment,
// exchanges it with our backend, then routes to the app (or the phone-completion step).
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/api/client";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setErr("لم يتم استلام رمز الجلسة من Google");
      setTimeout(() => nav("/login", { replace: true }), 2500);
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data?.token) localStorage.setItem("talabya_token", data.token);
        await refresh();
        // Clear the URL fragment so the token isn't left in history
        window.history.replaceState({}, document.title, "/");
        if (data?.needs_phone) {
          nav("/complete-profile", { replace: true });
        } else {
          const role = data?.user?.role;
          if (role === "admin") nav("/admin", { replace: true });
          else if (role === "driver") nav("/driver", { replace: true });
          else if (role === "restaurant") nav("/restaurant", { replace: true });
          else nav("/", { replace: true });
        }
      } catch (e) {
        setErr(e?.response?.data?.detail || "فشل تسجيل الدخول عبر Google");
        setTimeout(() => nav("/login", { replace: true }), 3000);
      }
    })();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center gradient-warm" data-testid="auth-callback">
      <div className="text-center px-6">
        {err ? (
          <>
            <div className="text-red-600 font-bold text-lg" data-testid="auth-callback-err">{err}</div>
            <div className="text-sm text-[var(--text-secondary)] mt-2">جاري إعادة التوجيه...</div>
          </>
        ) : (
          <>
            <img src="/icon-192.png" alt="طلبية" className="w-16 h-16 rounded-2xl object-cover mx-auto animate-pulse-dot"
                 style={{boxShadow:"0 4px 12px rgba(37,71,208,0.35)"}}/>
            <div className="mt-4 font-black text-lg" style={{fontFamily:"Cairo"}}>جاري تسجيل الدخول عبر Google...</div>
            <div className="text-sm text-[var(--text-secondary)] mt-1">لحظة من فضلك</div>
          </>
        )}
      </div>
    </div>
  );
}
